/* Hero.tsx generated by @compiled/babel-plugin v0.36.0 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { ax, ix, CC, CS } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { media } from '@atlaskit/primitives';
import VisuallyHidden from '@atlaskit/visually-hidden';
import { H3, Image } from '@atlassian/mpac-primitives';
import { TEST_ID } from '../constants';
import { YouTubeIframe } from './YouTubeIframe';
import { jsxs as _jsxs, jsx as _jsx } from "react/jsx-runtime";
const _20 = "@media (min-width:64rem){._10m4qfx8{flex-grow:5}._1vdkkb7n{flex-shrink:1}._1wznf1ug{flex-basis:0%}._10hl1h6o{text-align:center}}";
const _19 = "@media (min-width:64rem){._10m4qfx8{flex-grow:5}._1vdkkb7n{flex-shrink:1}._1wznf1ug{flex-basis:0%}._10hl18uv{text-align:initial}}";
const _18 = "._1ul9gew0{min-width:22.5rem}";
const _17 = "._16jlqfx8{flex-grow:5}";
const _16 = "@media (min-width:64rem){._isu4xncg{margin-bottom:var(--ds-space-800,4pc)}}";
const _15 = "@media (min-width:48rem) and (max-width:63.99rem){._1b7eoahv{margin-bottom:var(--ds-space-600,3pc)}}";
const _14 = "._otyrxy5q{margin-bottom:var(--ds-space-400,2pc)}";
const _13 = "._gy1pxy5q{column-gap:var(--ds-space-400,2pc)}";
const _12 = "._1p57pxbi{row-gap:var(--ds-space-200,1pc)}";
const _11 = "._1bsb1osq{width:100%}";
const _10 = "._1bah1h6o{justify-content:center}";
const _9 = "._1n261g80{flex-wrap:wrap}";
const _8 = "._1e0c1txw{display:flex}";
const _7 = "._4cvr1h6o{align-items:center}";
const _6 = "@media not all and (min-width:48rem){._12b61osq{min-width:100%}._1rkb1osq{max-width:100%}}";
const _5 = "._16jl1ohn{flex-grow:7}";
const _4 = "._1ul91pyr{min-width:31.5rem}";
const _3 = "._i0dlf1ug{flex-basis:0%}";
const _2 = "._1o9zkb7n{flex-shrink:1}";
const _ = "._16jlkb7n{flex-grow:1}";
const HeroContainer = null;
const TaglineContainer = null;
const TaglineCentered = null;
const HeroMediaContainer = null;
const HeroMedia = _ref => {
  let {
    youtubeId,
    heroImage,
    listingName
  } = _ref;
  if (youtubeId) return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_, _2, _3, _4, _5, _6]
    }), /*#__PURE__*/_jsx("div", {
      className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul91pyr _16jl1ohn _12b61osq _1rkb1osq"]),
      children: /*#__PURE__*/_jsx(YouTubeIframe, {
        youtubeId: youtubeId,
        imageAltText: listingName ? "watch ".concat(listingName, " video") : ''
      })
    })]
  });else if (heroImage) {
    return /*#__PURE__*/_jsxs(CC, {
      children: [/*#__PURE__*/_jsx(CS, {
        children: [_, _2, _3, _4, _5, _6]
      }), /*#__PURE__*/_jsx("div", {
        className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _1ul91pyr _16jl1ohn _12b61osq _1rkb1osq"]),
        children: /*#__PURE__*/_jsx(Image, {
          width: "100%",
          height: "100%",
          src: heroImage.url,
          "data-testid": TEST_ID.OVERVIEW_TAB_HERO_IMAGE,
          alt: "hero"
          // we can't enforce aspect ratio here as the publish flow allows arbitrary sizes
          // and enforcing can lead to very blurry hero images
          ,
          aspectRatio: heroImage.width / heroImage.height
        })
      })]
    });
  }
  return null;
};
export const Hero = props => {
  const hasHero = props.heroImage || props.youtubeId;
  return /*#__PURE__*/_jsxs(CC, {
    children: [/*#__PURE__*/_jsx(CS, {
      children: [_7, _8, _9, _10, _11, _12, _13, _14, _15, _16]
    }), /*#__PURE__*/_jsxs("section", {
      className: ax(["_4cvr1h6o _1e0c1txw _1n261g80 _1bah1h6o _1bsb1osq _1p57pxbi _gy1pxy5q _otyrxy5q _1b7eoahv _isu4xncg"]),
      children: [/*#__PURE__*/_jsxs(CC, {
        children: [/*#__PURE__*/_jsx(CS, {
          children: [_, _2, _3, _17, _18, _6, _19, _20]
        }), /*#__PURE__*/_jsx("div", {
          className: ax(["_16jlkb7n _1o9zkb7n _i0dlf1ug _16jlqfx8 _1ul9gew0 _12b61osq _1rkb1osq _10m4qfx8 _1vdkkb7n _1wznf1ug _10hl18uv", !hasHero && "_10m4qfx8 _1vdkkb7n _1wznf1ug _10hl1h6o"]),
          children: /*#__PURE__*/_jsxs(H3, {
            as: "h2",
            children: [props.ariaLabel && /*#__PURE__*/_jsx(VisuallyHidden, {
              children: props.ariaLabel
            }), props.tagline]
          })
        })]
      }), /*#__PURE__*/_jsx(HeroMedia, _objectSpread({}, props))]
    })]
  });
};